import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http"
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SigninService {
  baseURL: any = environment.baseURL;
  header: any;
  domainName: any;
  ssoAuthURL: any = environment.ssoAuthURL;

  constructor(private http: HttpClient) {
    this.header = new HttpHeaders({
      "Content-Type": "application/json",
      "apiKey": environment.apiKey
    });
  }
  signInAPICall(values: any): Observable<any> {
    let newHeader = this.commonHeader();
    return this.http.post(this.baseURL + 'v2/login', values, {
      headers: newHeader
    });
  }

  adminSignInAPICall(values: any): Observable<any> {
    let newHeader = this.commonHeader();
    return this.http.post(this.baseURL + 'admin/login', values, {
      headers: newHeader
    });
  }

  authOptionAPICall(values: any): Observable<any> {
    let newHeader = this.commonHeader();
    return this.http.post(this.baseURL + 'authOption', values, {
      headers: newHeader
    });
  }

  otpAPICall(values: any, id): Observable<any> {
    let newHeader = this.commonHeader();
    this.domainName = localStorage.getItem('DomainName')
    newHeader = newHeader.append('subdomain', this.domainName);
    return this.http.put(this.baseURL + 'validateOtp/' + id, values, {
      headers: newHeader
    });
  }
    commonHeader(){
      let newHeader = this.header;
      let tier = localStorage.getItem('Tier');
      newHeader = newHeader.append('tier', tier);
      return newHeader;
    }

    lmsLogin(values) {
      let newHeader = this.commonHeader();
      this.domainName = localStorage.getItem('DomainName')
      newHeader = newHeader.append('subdomain', this.domainName);
      return this.http.post(this.ssoAuthURL + '/login' , values, {
        headers: newHeader
      });
    }

    logoutAPICall(): Observable<any> {
      const logoutHeader = new HttpHeaders({
        apiKey: environment.apiKey
      });
      const logoutPayload = {
        userId: localStorage.getItem('userId') || '',
      };
      return this.http.post(this.baseURL + 'logout', logoutPayload, {
        headers: logoutHeader
      });
    }
}
